export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          {/* Left column */}
          <div className="md:col-span-5">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4">About Us</p>
            <h2
              data-testid="about-heading"
              className="text-3xl sm:text-4xl tracking-tight font-bold uppercase text-white"
            >
              Detailing<br />Perfected
            </h2>
          </div>

          {/* Right column */}
          <div className="md:col-span-7 space-y-6">
            <p className="text-base leading-relaxed text-[#A3A3A3]">
              What started as a shared passion for clean cars has grown into a dedicated mission to provide the best 
              automotive care in our community. As two long-time friends, we chose to channel our ambition into 
              mastering the art of detailing rather than settling for a typical summer job. We've built our service 
              on hard work and a goal of gaining real-world experience, ensuring our reputation stands out from the rest.
            </p>
            <p className="text-base leading-relaxed text-[#A3A3A3]">
              Our business is built on a simple belief: if a job is worth doing, it's worth doing right. We treat 
              every vehicle as if it were our own, using high-quality products and meticulous techniques to ensure 
              every inch is perfected. From deep interior cleaning to restoring a high-gloss exterior shine, we 
              don't just aim to meet your expectations — we aim to exceed them.
            </p>
            <p className="text-base leading-relaxed text-[#A3A3A3]">
              Choosing us means supporting young entrepreneurs who are hungry to prove themselves through quality 
              and reliability. While we may be young, our attention to detail and professional approach rival the 
              biggest shops in town. We take pride in being thorough and accessible, ensuring a seamless experience 
              from booking until we hand back your keys as we build a brand based on trust.
            </p>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { value: "100%", label: "Satisfaction Rate" },
            { value: "24/7", label: "Booking Available" },
            { value: "Premium", label: "Product Lineup" },
          ].map((stat) => (
            <div
              key={stat.label}
              data-testid={`stat-${stat.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="border border-[#262626] bg-[#141414] p-6 text-center bento-card"
            >
              <p className="text-3xl sm:text-4xl font-black text-white tracking-tighter">{stat.value}</p>
              <p className="mt-2 text-xs tracking-[0.2em] uppercase font-bold text-[#737373]">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
